import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-tasks',
  templateUrl: './admin-tasks.component.html',
  styleUrls: ['./admin-tasks.component.scss']
})
export class AdminTasksComponent implements OnInit {

  showMerge: boolean = true;
  showCopy: boolean = false;
  showFranchise: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  loadPage(pageNo) {
    console.log(pageNo);
    this.showMerge = false;
    this.showCopy = false;
    this.showFranchise = false;

    switch (pageNo.index) {
      case 0:
        this.showMerge = true;
        break;
      case 1:
        this.showCopy = true;
        break;
      case 2:
        this.showFranchise = true;
        break;

      default:
    }
  }
}
